 <template>
	<div class="window">
        <div class="header"><span v-html="translation.wpisz_imiona_graczy"></span>
            <a class="description" @click="openDescription"><information-circle-icon class="icon"/></a>
            <a class="settings" @click="openSettings"><cog-6-tooth-icon class="icon"/></a>
        </div>
        <div class="description-box">
            <div class="grey-box">
                <div class="input-group">
                    <label v-html="translation.twoje_imie"></label>
                    <input type="text" v-model="imie1" value="" class="config-input">
                </div>
                <div class="input-group">
                    <label v-html="translation.imie_drugiego_gracza"></label>
                    <input type="text" v-model="imie2" value="" class="config-input">
                </div>
            </div>
            <div class="alert-box" :class="(komunikat!='' || komunikatPolaczenia!='')?'visible':''">
                <div class="alert-text">
                    <div class="line2">{{ komunikat }}{{ komunikatPolaczenia }}</div>
                </div>
            </div>
            <div class="help-box mt2x">
                <div class="help-text" v-html="translation.help5">
                </div>
            </div>
            <button class="btn btn-all btn-green" @click="goNext" v-html="translation.wyslij_zaproszenie"></button>
        </div>
        <a class="back-screen" @click="doNowejGry"><chevron-left-icon class="icon" /><span v-html="translation.back"></span></a>
    </div>
</template>

<script>
import de from '../locale/de.js';
import en from '../locale/en.js';
import es from '../locale/es.js';
import fr from '../locale/fr.js';
import it from '../locale/it.js';
import pl from '../locale/pl.js';
import pt from '../locale/pt.js';
import { Cog6ToothIcon, InformationCircleIcon, ChevronLeftIcon } from '@heroicons/vue/24/solid';

export default {
    name: 'KonfiguracjaGry',
    props: {
        language: String,
        komunikatPolaczenia: String
    },
    components: { 
        Cog6ToothIcon,
        InformationCircleIcon,
        ChevronLeftIcon
        
    },
    data() {
        return {
            lang: localStorage.getItem('language'),
            translation: pl,
            theme: localStorage.getItem('theme'),
            imie1: '',
            imie2: '',
            komunikat:'',
        }
    },
    beforeMount() {
        switch(localStorage.getItem('language'))
        {
            case 'de':
                this.translation = de;
                break;
            case 'en':
                this.translation = en;
                break;
            case 'es':
                this.translation = es;
                break;
            case 'fr':
                this.translation = fr;
                break;
            case 'it':
                this.translation = it;
                break;
            case 'pt':
                this.translation = pt;
                break;
            default:
                this.translation = pl;
                break;
        }
    },
    methods: {
        goNext() {
            //sprawdzenie czy oba imiona sa wpisane w jak nie to pokazac z tlumaczenia "wpisz_imiona"
            if (this.imie1 == '' || this.imie2 == '') {
                this.komunikat=this.translation.wpisz_imiona_graczy;
            } else {
                this.komunikat='';
                /*
                wysylam konfiguracje
                */
                this.$emit('configure-game', this.imie1, this.imie2);
            }
        },
        doNowejGry() {
            this.$emit('go-nowa-gra');
        },
        openSettings() {
            this.$emit('open-settings');
        },
        openDescription() {
            this.$emit('open-description');
        },
    },
    watch: {
        language(l) {
            this.lang = l;
            switch(localStorage.getItem('language'))
            {
                case 'de':
                    this.translation = de;
                    break;
                case 'en':
                    this.translation = en;
                    break;
                case 'es':
                    this.translation = es;
                    break;
                case 'fr':
                    this.translation = fr;
                    break;
                case 'it':
                    this.translation = it;
                    break;
                case 'pt':
                    this.translation = pt;
                    break;
                default:
                    this.translation = pl;
                    break;
            }

        }
    },
}
</script>

<style scoped>
a.back-screen {
    position:fixed;
    left:10px;
    bottom:10px;
    color: var(--bs-button-text);
}
a.back-screen svg {
    width: 15px;
    margin-top:5px;
    position:absolute;
}
a.back-screen span {
    padding-left: 20px;
}
.header {
    font-weight:bold;
    border-bottom: 1px solid var(--bs-gradient-to);
    -webkit-box-shadow: 0px 0px 10px 0px rgba(243, 40, 120, 1);
    -moz-box-shadow: 0px 0px 10px 0px rgba(243, 40, 120, 1);
    box-shadow: 0px 0px 10px 0px rgba(243, 40, 120, 1);
    color: white;
    height:50px;
    display: block;
    line-height: 50px;
    position:fixed;
    top:0;
    left:0;
    right:0;
    text-align:left;
    padding: 0 20px;
    background-color: var(--bs-gradient-to);
}

a.settings svg {
    width: 25px;
    position:absolute;
    right: 20px;
    top:12px;
}

a.description svg {
    width: 25px;
    position:absolute;
    right: 60px;
    top:12px;
}
.description-box {
    padding: 0 20px;
    background-color:var(--bs-button-background);
    color: var(--bs-button-text);
    position: fixed;
    top: 50px;
    left: 0;
    right: 0;
    bottom: 60px;
    overflow: auto;
}

.btn.btn-all {
    font-size: 1em;
    height: 3em;
    width: 100%;
    border-radius: 10px;
    margin: 0;
    font-weight:bold;
    position: relative;
}
button.btn {
    font-size: 1em;
    font-family: 'Jost', sans-serif;
}
.btn-green {
    background-color: var(--bs-gradient-to);
    color: var(--bs-pink-button-color);
    position: relative;
    border-color:white;
    border: 0 none;
}
.btn-green::after {
    content: '';
    position: absolute;
    right: 20px;
    top: 50%;
    width: 12px;
    height: 12px;
    border-right: 2px solid var(--bs-pink-button-color);
    border-bottom: 2px solid var(--bs-pink-button-color);
    transform: translateY(-50%) rotate(-45deg);
    animation: chevronPulse 1s infinite;
    transition: transform 0.3s ease;
}

@keyframes chevronPulse {
    0%, 100% {
        transform: translateY(-50%) rotate(-45deg) translateX(0);
        opacity: 1;
    }
    50% {
        transform: translateY(-3px) rotate(-45deg) translateX(5px);
        opacity: 0.5;
    }
}

@keyframes alertPulse {
    0%, 100% {
        transform: rotate(15deg) scale(1);
    }
    50% {
        transform: rotate(15deg) scale(1.5);
    }
}

.mt2x {
    margin: 0.5em 0;
}

div.grey-box {
    margin: 2em 0 .5em;
    overflow: auto;
    background: var(--bs-box-background);
    border: var(--bs-settings-button-border);
    border-radius: 8px;
    padding: 20px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    position: relative;
    overflow: hidden;
}

.input-group {
    display: block;
    margin-bottom: 1em;
}
.input-group label {
    display: block;
}

.input-group input[type='text'] {
    border-top: 1px solid #d0d0d0;
    border-left: 1px solid #d0d0d0;
    border-right: 1px solid #d0d0d0;
    border-bottom: 1px solid #4e4b66;
    padding: 10px;
    background-color: var(--bs-start-text);
    font-size: 16px;
    color: black;
    width: calc(100% - 25px);
    display: block;
    text-align:center;
    font-weight:bold;
    letter-spacing:2px;
}

 .alert-box {
            background: #fef9e7;
            border: 1px solid #f59e0b;
            border-radius: 8px;
            padding: 20px;
            box-shadow: 0 4px 12px rgba(245, 158, 11, 0.2);
            position: relative;
            overflow: hidden;
            visibility:hidden;
        }
.alert-box.visible {
    visibility: visible;
}
        .alert-box::before {
            content: '⛔';
            position: absolute;
            top: -10px;
            right: -10px;
            font-size: 80px;
            opacity: 0.15;
            transform: rotate(15deg);
            animation: alertPulse 1s infinite;

        }

        .alert-text {
            position: relative;
            z-index: 1;
            color: #991b1b;
            line-height: 1.5;
            margin: 0;
        }

        .alert-text .line2 {
            font-weight:bold;
        }
</style>
